import cn from 'classnames';
import { ReactNode } from 'react';
import './styles.scss';

interface FormButtonsProps {
	children: ReactNode;
	buttonCount?: string | 'single' | 'double';
}
export const FormButtons = (props: FormButtonsProps) => {
	const { children, buttonCount } = props;

	return <div className={cn(`formButtons formButtons--${buttonCount || 'double'}`)}>{children}</div>;
};

export default FormButtons;
